import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {FaSolidIcon} from "../../../../components/FontAwesomeIcons";
import ModalPortalHOC from "../../../../components/BaseComponents/ModalPortalHOC";
import {ModuloHRAPI} from "../../../../api/ModuloHR/ModuloHRAPI";
import SelfCareDipendenteModal from "../ModuloHR/TimeoffRequests/SelfCareDipendenteModal";
import {AppIconThumbnail} from "../../../../components/BaseComponents/AppIconThumbnail";
import AppConfig from "../../../../config/AppConfig";

export class StaffMemberAreaButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageOpen: false,
            staffList: [],
            staffLoading: true
        };
    }

    componentDidMount() {
        ModuloHRAPI.Staff.list()
            .then(staffList => {
                this.setState({staffList: staffList || [], staffLoading: false});
            })
            .catch(_ => {
                this.setState({staffList: [], staffLoading: false});
            });
    }

    handlePageOpen = _ => this.setState({pageOpen: true});
    handlePageClose = _ => this.setState({pageOpen: false});

    render() {
        if (this.state.staffLoading || !this.state.staffList.length) return '';

        return (
            <Fragment>
                <div className={"container mt-3"}>
                    <div className={"bg-white shadow-sm rounded py-2 text-primary"} onClick={this.handlePageOpen}>
                        <div className={"d-flex align-items-center justify-content-center"}>
                            <FaSolidIcon name={"user"}/>
                            <div className={"ml-2"}>Area dipendente</div>
                        </div>
                    </div>
                </div>
                <ModalPortalHOC>
                    {
                        this.state.pageOpen &&
                        <SelfCareDipendenteModal
                            staffList={this.state.staffList}
                            onDismiss={this.handlePageClose}
                            active={this.state.pageOpen}
                        />
                    }
                </ModalPortalHOC>
            </Fragment>
        );
    }
}

StaffMemberAreaButton.propTypes = {
    user: PropTypes.object.isRequired
};
